import UBox from 'src/components/ui/Ubox'
import Card from './components/card/card'
import * as S from './styles'

import {
  Box,
  Button,
  ButtonGroup,
  Grid,
  Typography,
  useMediaQuery,
  useTheme
} from '@material-ui/core'
import { useEffect, useRef, useState } from 'react'
import {
  DragDropContext,
  Draggable,
  Droppable,
  DropResult,
  ResponderProvided
} from 'react-beautiful-dnd'
import LoadingGeral from 'src/components/ui/LoadingGeral'
import { ISolicitacaoKanban } from 'src/contexts/SolicitacoesKanban/types'
import useSolicitacoesKanban from 'src/contexts/SolicitacoesKanban/useSolicitacaoKanban'
import { SimulacaoFinanciamentoResponse } from 'src/types'
import { SynRoutes } from 'src/core/consts/synRoutes'
import { useHistory } from 'react-router-dom'

export default function Board() {
  const { colunas, loading } = useSolicitacoesKanban()
  const history = useHistory()
  const theme = useTheme()
  const ehXS = useMediaQuery(theme.breakpoints.down('xs'))
  const [modoVisualizacao, setModoVisualizacao] = useState<
    'CARD' | 'LIST' | 'KANBAN'
  >('CARD')
  const [esconderSetaAvancar, setEsconderSetaAvancar] = useState<boolean>(false)
  const [esconderSetaVoltar, setEsconderSetaVoltar] = useState<boolean>(false)

  async function handleDragEnd(
    result: DropResult,
    provided: ResponderProvided
  ) {
    try {
      const { source, destination, type, draggableId } = result

      if (!destination) return

      if (
        source.droppableId === destination.droppableId &&
        source.index === destination.index
      ) {
        return
      }

      if (type === 'group') {
        //obter o id da lista a partir do droppable-id
        var listaSourceId = source.droppableId.replace('droppable-', '')
        var listaDestinationId = destination.droppableId.replace(
          'droppable-',
          ''
        )

        var indexListaSource = colunas.findIndex(f => f.id === listaSourceId)

        var indexListaDestination = colunas.findIndex(
          f => f.id === listaDestinationId
        )

        var novaLista = JSON.parse(JSON.stringify(colunas))

        var listaSource = novaLista[indexListaSource]
          .itens as SimulacaoFinanciamentoResponse[]
        var listaDestination = novaLista[indexListaDestination]
          .itens as SimulacaoFinanciamentoResponse[]
        //Salvar na lista e com o index correto

        //Remover da lista source uma lista
        const sourceIndex = source.index
        const destinationIndex = destination.index

        //Add a lista destination
        const [removedStore] = listaSource?.splice(sourceIndex, 1)
        listaDestination.splice(destinationIndex, 0, removedStore)

        novaLista[indexListaSource].itens = listaSource
        novaLista[indexListaDestination].itens = listaDestination
        //   const estadoAnterior = JSON.parse(
        //     JSON.stringify(listaStatusFinanciamento)
        //   )
        //   setListaStatusFinanciamento(novaLista)

        if (indexListaSource !== indexListaDestination) {
          // var item = lstSimulacaoFinanciamento.find(i => i.id === draggableId)
          // setItemSelecionado(item)
          // if (!!item) {
          //   await Swal.fire({
          //     title: 'Atenção!',
          //     text:
          //       'As mudanças de status por padrão são automaticas. Deseja alterar manualmente?',
          //     icon: 'warning',
          //     showCancelButton: true,
          //     cancelButtonText: 'Cancelar',
          //     confirmButtonText: 'Sim'
          //   }).then(async result => {
          //     if (result.isConfirmed) {
          //       await alterarStatus(draggableId, listaDestinationId)
          //       // setListaStatusFinanciamento(novaLista)
          //     } else {
          //       setListaStatusFinanciamento(estadoAnterior)
          //     }
          //   })
          // }
        }
      }
    } catch (error) {}
  }

  function atualizarMais(coluna) {
    coluna.carregarMais()
  }

  function obterContainerKanban() {
    return window.document?.querySelector('.container-kanban')
  }

  function handleScrollKanban() {
    var containerKanban = obterContainerKanban()
    if (!!containerKanban) {
      setEsconderSetaAvancar(scrollNoFinal(containerKanban))
      setEsconderSetaVoltar(scrollNoInicio(containerKanban))
    }
  }

  function scrollNoInicio(containerKanban: Element) {
    const isAtLeftStart = containerKanban.scrollLeft === 0
    return isAtLeftStart
  }

  function scrollNoFinal(containerKanban: Element) {
    const isAtRightEnd =
      containerKanban.scrollLeft + containerKanban.clientWidth >=
      containerKanban.scrollWidth

    return isAtRightEnd
  }

  function scrollKanban(voltar = false) {
    var containerKanban = obterContainerKanban()
    if (!!containerKanban) {
      let posicao = 0
      if (!voltar && !scrollNoFinal(containerKanban)) {
        posicao = 10
      }
      if (voltar && !scrollNoInicio(containerKanban)) {
        posicao = -10
      }
      containerKanban.scrollTo(
        containerKanban.scrollLeft + posicao,
        containerKanban.scrollTop
      )
    }
  }
  const scrollIntervalRef = useRef(null)

  const iniciaScrollKanban = (voltar = false) => {
    if (scrollIntervalRef.current) return // evita múltiplos intervalos
    scrollIntervalRef.current = setInterval(() => {
      scrollKanban(voltar)
    }, 15) // dispara a cada 500ms
  }

  const stopScrollKanban = () => {
    clearInterval(scrollIntervalRef.current)
    scrollIntervalRef.current = null
  }

  useEffect(() => {
    setTimeout(() => {
      if (!!window && !!document) {
        var divContainerKanban = obterContainerKanban()
        divContainerKanban.addEventListener('scroll', handleScrollKanban)
        var syn = window.document?.querySelector('.syn-container')
        if (!!syn) syn?.classList.add('no-padding')
      }
    }, 100)
    return () => {
      if (!!window && !!document) {
        var divContainerKanban = obterContainerKanban()
        try {
          divContainerKanban.removeEventListener('scroll', handleScrollKanban)
        } catch (error) {
          console.log(error)
        }
        var syn = window.document?.querySelector('.syn-container')
        if (!!syn) syn.classList.remove('no-padding')
      }
    }
  }, [])

  const isKanbanPage = document.location.href.includes('kanban');

  return (
    <UBox>
      <UBox render={!loading} p={2}>
        {!ehXS && (
          <Grid item xs={12} sm={12}>
            <Box
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'flex-end'
              }}
            >
              <ButtonGroup
                size="small"
                aria-label="small outlined button group"
              >
                <Button
                  onClick={() =>
                    history.push(SynRoutes.listagemOrcamentosOperacional)
                  }
                  color={'default'}
                  variant={'outlined'}
                  id="button-card-kanban"
                >
                  Card
                </Button>
                <Button
                  onClick={() =>
                    history.push(SynRoutes.listagemOrcamentosOperacional)
                  }
                  color={'default'}
                  variant={'outlined'}
                  id="button-lista-kanban"
                >
                  Lista
                </Button>
                <Button
                  onClick={() => {}}
                  color={'primary'}
                  variant={'contained'}
                  id="button-kanban-view"
                >
                  Kanban
                </Button>
              </ButtonGroup>
            </Box>
          </Grid>
        )}
      </UBox>

      <S.Board
        esconderSetaAvancar={esconderSetaAvancar}
        esconderSetaVoltar={esconderSetaVoltar}
      >
        <S.EarLeft
          className="ear-kanban ear-left-kanban"
          onMouseLeave={stopScrollKanban}
          onMouseEnter={() => iniciaScrollKanban(true)}
        />
        <S.EarRight
          className="ear-kanban ear-right-kanban"
          onMouseEnter={() => iniciaScrollKanban()}
          onMouseLeave={stopScrollKanban}
        />
        <DragDropContext onDragEnd={handleDragEnd}>
          <S.Container className="container-kanban">
            {loading && <LoadingGeral />}

            {!loading &&
              colunas?.map(coluna => (
                <S.Coluna key={'status-' + coluna.id}>
                  <UBox
                    style={{
                      background: '#eee',
                      borderRadius: '4px'
                    }}
                    p={1}
                    mb={1}
                  >
                    <Typography variant="body2" style={{ fontSize: '.9rem' }}>
                      <small>
                        <strong>{coluna.titulo}</strong> ({coluna.qtdTotal})
                      </small>
                    </Typography>
                  </UBox>

                  <Droppable
                    droppableId={'droppable-' + coluna.id}
                    type="group"
                  >
                    {(provided, snapshot) => (
                      <div ref={provided.innerRef} {...provided.droppableProps}>
                        <S.InfiniteScrollColuna
                          pageStart={0}
                          loadMore={() =>
                            !coluna.loading && coluna.carregarMais(coluna.id)
                          }
                          useWindow={false}
                          className={'el-scroll-column' + coluna.id}
                          getScrollParent={() =>
                            document.querySelector(
                              '.el-scroll-column' + coluna.id
                            )
                          }
                          hasMore={coluna.qtdTotal > coluna.dados.length}
                          isDraggingOver={snapshot.isDraggingOver}
                          loader={
                            coluna.qtdTotal > coluna.dados.length && (
                              <LoadingGeral />
                            )
                          }
                        >
                          {coluna.dados.map(
                            (solicitacao: ISolicitacaoKanban, i) => (
                              <Draggable
                                draggableId={solicitacao.id}
                                key={solicitacao.id}
                                index={i}
                              >
                                {(providedDrag, snapshotDrag) => (
                                  <div
                                    {...providedDrag.dragHandleProps}
                                    {...providedDrag.draggableProps}
                                    ref={providedDrag.innerRef}
                                    key={i}
                                  >
                                    <UBox mt={1} m={1} className="card-kanban">
                                      <Card solicitacao={solicitacao} />
                                    </UBox>
                                  </div>
                                )}
                              </Draggable>
                            )
                          )}
                          {provided.placeholder}
                        </S.InfiniteScrollColuna>
                      </div>
                    )}
                  </Droppable>
                </S.Coluna>
              ))}
          </S.Container>
        </DragDropContext>
      </S.Board>
    </UBox>
  )
}
